<template>
  <div id="content" class="scouting_space" v-if='search_field.scouting_challenge'>
    <BlockedModal :dialogVisible='showBockedDialog' @close="closeBlockedDialog()"  :formMessage="formMessage"></BlockedModal>

    <ScoutingNextStepInfo :dialogVisible='showConfirmDialog'  @close="closeConfirmDialog" @confirm="validateScoutingBrief()" ></ScoutingNextStepInfo>

    <div class="" v-if="1 == 1">

    <!-- <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="validateScoutingBrief($event)" message="After submission, your brief will be shared with Innopearl for review." ></ConfirmModal> -->

    <div class="container">

      <AddCommentModal :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>

    <div class="scouting_space_stepper">
      <button :class="[
        'step',
        (step == 1) ? 'active' : '',
      ]" @click="save(false);step = 1;">
        <span class="stepNumber ">1</span> <span class="stepName">Validate your scouting brief</span>
      </button>
      <button :class="[
        'step',
        (step == 2) ? 'active' : '',
      ]" @click="save(false);step = 2" v-if="search_field.scouting_challenge.isCustomerRequired != true">
        <span class="stepNumber">2</span> <span class="stepName">Validate your candidates selection requirements</span>
      </button>
    </div>


    <div class=" scouting_space_1" v-if="step == 1">
      <div id="element-to-convert">


      <div class="row">
        <div class="col-12 text-center">
           <span class="search_field_name">{{search_field.name}}</span>
           <span class="search_field_projectname">from project {{search_field.fullProject.name}}</span>
        </div>
      </div>
      <div class="row scouting_space_content" v-if="search_field.scouting_challenge">
        <!-- problem_to_be_solved -->
          <div class="col-12 col-lg-6 col">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_problem_to_be_solved.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">PROBLEM TO BE SOLVED <span class="scouting_brief_item_subtitle"> (from your business challenge)</span></span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.problem_to_be_solved.value" class="addValueInput"  rows="4"   ></textarea>
                  <div class="smallEditedLabel " v-if="showEdited && search_field.scouting_challenge.editedFields.problem_to_be_solved">
                      Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                  </div>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.problem_to_be_solved.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.problem_to_be_solved.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.problem_to_be_solved.comments" :key="i">
                    <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                        <span v-else>{{comment}}</span>
                      </div>

                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("problem_to_be_solved")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>
          <!-- recommanded_application_area -->
          <div class="col-12 col-lg-6 col">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_recommended_application_area.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">POTENTIAL INDUSTRIES</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.recommanded_application_area.value" class="addValueInput"  rows="4"   ></textarea>
                  <div class="smallEditedLabel " v-if="showEdited && search_field.scouting_challenge.editedFields.recommanded_application_area">
                      Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                  </div>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.recommanded_application_area.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.recommanded_application_area.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.recommanded_application_area.comments" :key="i">
                    <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("recommanded_application_area")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>

          <!-- partnership_objectives -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_partnership_objective.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">PARTNERSHIP OBJECTIVE <span class="scouting_brief_item_subtitle">(from your business challenge)</span></span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.partnership_objectives.value" class="addValueInput"  rows="4"   ></textarea>
                  <div class="smallEditedLabel " v-if="showEdited && search_field.scouting_challenge.editedFields.partnership_objectives">
                      Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                  </div>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.partnership_objectives.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.partnership_objectives.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.partnership_objectives.comments" :key="i">
                    <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("partnership_objectives")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>


          <!-- anticipated_impact -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_anticipated_impact.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">ANTICIPATED IMPACT ON BUSINESS OR OPERATING MODEL</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.anticipated_impact.value" class="addValueInput"  rows="4"   ></textarea>
                  <div class="smallEditedLabel " v-if="showEdited && search_field.scouting_challenge.editedFields.anticipated_impact">
                      Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                  </div>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.anticipated_impact.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.anticipated_impact.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.anticipated_impact.comments" :key="i">
                    <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("anticipated_impact")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>


          <!-- recommanded_topics -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_recommended_topics.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">RECOMMENDED TOPICS / TECHNOLOGIES</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.recommanded_topics.value" class="addValueInput"  rows="4"   ></textarea>
                  <div class="smallEditedLabel " v-if="showEdited && search_field.scouting_challenge.editedFields.recommanded_topics">
                      Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                  </div>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.recommanded_topics.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.recommanded_topics.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.recommanded_topics.comments" :key="i">
                    <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("recommanded_topics")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>


          <!-- key_engagment_steps -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_key_engagement_steps.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">OTHER CONSIDERATIONS OR POTENTIAL HURDLES</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.key_engagment_steps.value" class="addValueInput"  rows="4"   ></textarea>
                  <div class="smallEditedLabel " v-if="showEdited && search_field.scouting_challenge.editedFields.key_engagment_steps">
                      Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                  </div>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.key_engagment_steps.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.key_engagment_steps.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.key_engagment_steps.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("key_engagment_steps")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>

          <div class="col-12 col-lg-6 mt50">
              <div class=" text-center">
                <span style="display:block;color:#3783C5;text-transform:uppercase;font-size:18px;line-height:21px;margin-top:20px;">Keep your name confidential for potential candidates?</span>
                <label class="rocker mt20 ">
            <input type="checkbox" v-model="search_field.scouting_challenge.scouting_brief.keep_name_confidential"  >
            <span class="switch-left">YES</span>
            <span class="switch-right">NO</span>
          </label>


              </div>
          </div>
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item text-center" style="padding:50px;">
                          <span class="scouting_brief_item_title">ADDITIONAL INSIGHTS</span>
                        <button class="addMoreInfoBtn" @click="addMoreInfo = true" v-if="addMoreInfo == false && !search_field.scouting_challenge.scouting_brief.extra_info"  :disabled="search_field.isSubmit" >
                      <img :src="require('@/assets/search_field_1_add_more_information.svg')" alt="" style="width:60px">
                      <span style="display:block;color:#3783C5;text-transform:uppercase;font-size:10px;line-height:15px;margin-top:20px;">Add more information</span>

                </button>


                <textarea v-model="search_field.scouting_challenge.scouting_brief.extra_info" class="addValueInput" rows="4" v-if="addMoreInfo == true || search_field.scouting_challenge.scouting_brief.extra_info" ></textarea>
                <div class="smallEditedLabel " v-if="addMoreInfo == true && showEdited && search_field.scouting_challenge.editedFields.extra_info">
                    Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                </div>

              </div>
          </div>




      </div>
      </div>
      <!-- <div class="step_footer">
        <button type="button" name="button" class="next_step_btn" @click='step++'>
          Next step
          <img :src="require('@/assets/next.svg')" alt="">
        </button>
      </div> -->
      <div class="alert alert-info mt50" v-if="search_field.scouting_challenge && search_field.scouting_challenge.isSubmit">
The scouting brief has been successfully completed

      </div>
      <div class="rinfo_last_update mt20 notice" v-if="search_field.scouting_challenge.lastUpdateAt">

      Last update : {{search_field.scouting_challenge.lastUpdateAt}} <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
    </div>
      <div class="step_footer stickitfooter">

        <div class="row row_center  ">
        <div class="col-6 text-left" v-if="search_field.project">
          <router-link v-if="search_field.project" type="button" name="button" class="prev_step_btn" :to='"/projet/"+search_field.project.$oid'>
            <img :src="require('@/assets/prev.svg')" alt="">
            BACK TO DASHBOARD

          </router-link>
        </div>
          <div class="col-6 text-right" v-if="search_field.scouting_challenge">
            <button type="button" name="button" class="next_step_btn" @click="save(true)" v-if="search_field.scouting_challenge.isSubmit != true && this.blockSaveAndSubmit == false">
              <img :src="require('@/assets/validate.svg')" alt="">
              Save
            </button>
            <button type="button" name="button" class="next_step_btn" @click="update(true)" v-if="search_field.scouting_challenge.isSubmit == true">
              <img :src="require('@/assets/validate.svg')" alt="">
              Update
            </button>
            <button type="button" name="button" class="next_step_btn" @click='step++' v-if="search_field.scouting_challenge.isCustomerRequired != true">
              Next step
              <img :src="require('@/assets/next.svg')" alt="">
            </button>
            <button type="button" name="button" class="next_step_btn" @click="confirmValid" v-if="search_field.scouting_challenge.isCustomerRequired == true && this.blockSaveAndSubmit == false">
              <img :src="require('@/assets/validate.svg')" alt="">
              VALIDATE AND SUBMIT FOR REVIEW
            </button>
          </div>
        </div>

      </div>
    </div>


    <div class=" scouting_space_2" v-if="step == 2">
      <!-- <ExplanationLink text="EXPLANATIONS NEEDED?" link="/"/> -->

      <div class="row">
        <div class="col-12 text-center">
           <span class="search_field_name">{{search_field.name}}</span>
            <span class="search_field_projectname">from project {{search_field.fullProject.name}}</span>
        </div>
      </div>
      <div class="scouting_space_content">


      <div class="row ligne_form">
        <div class="col-12 col">
            <div class="zone_input">
                <div class="zone_input_header">
                  <img :src="require('@/assets/search_field_2_solution_developement_stage.svg')" class="zone_input_icon" alt="">
                  <span class="zone_input_name">SOLUTION DEVELOPMENT STAGE
                    <!-- <div class="tooltip-right tooltip-mobile" data-tooltip="Explanation about this field">
                        <img :src="require('@/assets/info.svg')" alt="" class="explanation_needed_icon">
                    </div> -->
                  </span>
                </div>
                <div class="triangle_container">
                  <div class="text-center triangle_right" style="">
                    PRE-COMMERCIAL DEVELOPMENT AND VALIDATION
                  </div>
                  <div class="text-center triangle_left" >
                    COMMERCIAL MARKET
                  </div>
                </div>
                <div class="myCheck">
  <label class="mdl-checkbox mdl-js-checkbox  mdl-js-ripple-effect"  v-for="(fs,i) in solution_developement_stages" :key="i">
      <input type="checkbox" :value="fs.value" v-model="search_field.scouting_challenge.candidate_selection_requirements.development_stage" class="mdl-checkbox__input"   />
      <span class="mdl-checkbox__label">{{fs.name}}</span>
  </label>

</div>
            </div>
            <div class="smallEditedLabel moremtp" v-if="showEdited && search_field.scouting_challenge.editedFields.development_stage">
                Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
            </div>
        </div>
      </div>

      <div class="row ligne_form">
        <div class="col-12 col">
            <div class="zone_input">
                <div class="zone_input_header">
                  <img :src="require('@/assets/search_field_2_funding_stage.svg')" class="zone_input_icon" alt="">
                  <span class="zone_input_name">FUNDING STAGE</span>
                  <!-- <div class="tooltip-right tooltip-mobile" data-tooltip="Explanation about this field">
                      <img :src="require('@/assets/info.svg')" alt="" class="explanation_needed_icon">
                  </div> -->
        </div>
                  <div class="myCheck ml0-xs">
    <label class="mdl-checkbox mdl-js-checkbox  mdl-js-ripple-effect"  v-for="(fs,i) in funding_stage_possibles" :key="i">
        <input type="checkbox" :value="fs.value" v-model="search_field.scouting_challenge.candidate_selection_requirements.funding_stage" class="mdl-checkbox__input"  />
        <span class="mdl-checkbox__label">{{fs.name}}</span>
    </label>

</div>
<div class="smallEditedLabel moremtp" v-if="showEdited && search_field.scouting_challenge.editedFields.funding_stage">
    Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
</div>
            </div>
        </div>
        <div class="col-12 col">
            <div class="zone_input">
                <div class="zone_input_header">
                  <img :src="require('@/assets/search_field_2_partners_location.svg')" class="zone_input_icon" alt="">
                  <span class="zone_input_name">PARTNER'S LOCATION</span>
                </div>
              <div class="locationSelector ml0-xs" >
                <!-- <label class="location_selection" v-for='(loc,i) in location_possibles' :key="i">
                <input
      type="checkbox"
      :name="loc.value"
      :value="loc.value"
      id="location_Selec"
      v-model="search_field.scouting_challenge.candidate_selection_requirements.location"
      :disabled="search_field.scouting_challenge.isSubmit"
    />
    {{loc.name}}</label> -->
    <treeselect v-model="search_field.scouting_challenge.candidate_selection_requirements.location" :multiple="true" :options="execution_geography_possibles" />
    <div class="smallEditedLabel nomtp" v-if="showEdited && search_field.scouting_challenge.editedFields.location">
        Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
    </div>

    <!-- <div class=" add_other_inline" v-if="search_field.scouting_challenge.isSubmit != true">
        <input type="name" v-model="add_other_location" placeholder="Add a location"/>
        <button type="button" name="button" @click="addCustomLocation" i>OK</button>
    </div> -->
  </div>
            </div>
        </div>
      </div>

      <div class="row ligne_form">
        <div class="col-12 col-xl-8 col">
            <div class="zone_input">
              <div class="zone_input_header">
                <img :src="require('@/assets/search_field_2_what_type_of_assets.svg')" class="zone_input_icon" alt="">
                <span class="zone_input_name">WHAT TYPE OF ASSETS / CAPABILITIES A POTENTIAL PARTNER MUST HAVE?</span>
              </div>

              <div class="vselect_container ml65 mt20 ml0-xs" >
                <v-autocomplete v-model="search_field.scouting_challenge.candidate_selection_requirements.capabilities_assets" closable-chips  :items="capabilities_assets_possibles" item-color="#FFF" item-title="name" item-value="value"  chips multiple></v-autocomplete>
                <div class="smallEditedLabel " v-if="showEdited && search_field.scouting_challenge.editedFields.capabilities_assets">
                    Edited <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
                </div>
                <div class="add_custom_key_factor" v-if="search_field.scouting_challenge.isSubmit != true">
                  <span>You don’t find what you are looking for ?</span>
                  <button type="button" name="button" @click='dialogAssets = true' :disabled="search_field.scouting_challenge.isSubmit">+ ADD</button>
                  <NewValueModal :dialogVisible='dialogAssets' @close="dialogAssets=false" @newValueIsProposed="setNewValueCAS($event)" formName="Add your assets / capabilities" ></NewValueModal>
                </div>
              </div>


            </div>
        </div>
      </div>

      <div class="row ligne_form">
        <div class="col-12 col-xl-8 col">
          <div class="row ">
            <div class="col-12 mt20">
              <span class="zone_input_name">POTENTIAL PARTNERS ALREADY IDENTIFIED?</span>
            <label class="rocker mt20 ml20">
        <input type="checkbox" v-model="search_field.scouting_challenge.candidate_selection_requirements.already_identified"  >
        <span class="switch-left">YES</span>
        <span class="switch-right">NO</span>
      </label>
    </div>
          </div>
        </div>
      </div>


      <div class="row ligne_form">
        <div class="col-12 col">
          <textarea v-model="search_field.scouting_challenge.candidate_selection_requirements.comments" class="comments" placeholder="Comments"  ></textarea>

        </div>
      </div>
      </div>

      <div class="alert alert-info mt50" v-if="search_field.scouting_challenge && search_field.scouting_challenge.isSubmit">
      The scouting brief has been successfully completed
      </div>

      <div class="col-12 text-center mt50">
        <button type="button" name="button" class="downloadBtnWhite" @click="generateReport">
          <img :src="require('@/assets/greyDownload.svg')" alt="">
          DOWNLOAD THE BRIEF</button>
      </div>
      <div class="info_last_update notice mt20" v-if="search_field.scouting_challenge.lastUpdateAt">
        Last update : {{search_field.scouting_challenge.lastUpdateAt}} <span v-if="search_field.scouting_challenge.lastUpdateBy">by {{search_field.scouting_challenge.lastUpdateBy.firstname}} {{search_field.scouting_challenge.lastUpdateBy.lastname}}</span>
      </div>
      <div class="step_footer stickitfooter">

        <div class="row row_center  ">
          <div class="col-12 col-xl-6 text-left">
            <button type="button" name="button" class="prev_step_btn" @click='step = step - 1'>
              <img :src="require('@/assets/prev.svg')" alt="">
              Previous step
            </button>
          </div>
          <div class="col-12 col-xl-6 text-right">
            <button type="button" name="button" class="next_step_btn" @click="save(true)" v-if="search_field.scouting_challenge.isSubmit != true && this.blockSaveAndSubmit == false">
              <img :src="require('@/assets/validate.svg')" alt="">
              Save
            </button>
            <button type="button" name="button" class="next_step_btn" @click="update(true)" v-if="search_field.scouting_challenge.isSubmit == true">
              <img :src="require('@/assets/validate.svg')" alt="">
              Update
            </button>
            <button type="button" name="button" class="next_step_btn" @click="confirmValid" v-if="search_field.scouting_challenge.isSubmit != true && this.blockSaveAndSubmit == false" >
              <img :src="require('@/assets/validate.svg')" alt="">
              VALIDATE FOR SCOUTING
            </button>
            <!-- <button type="button" name="button" class="next_step_btn" @click="gobackrouter()" v-if="search_field.scouting_challenge.isSubmit == true">
              <img :src="require('@/assets/validate.svg')" alt="">
              Return to previous screen
            </button> -->
          </div>
        </div>

      </div>
    </div>


  </div>


 <vue3-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :filename="'Scouting brief for '+search_field.name"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      ref="html2Pdf"
      v-if="search_field.scouting_challenge"
  >
      <template  v-slot:pdf-content>
          <section style="width:100%;
          height:29.7cm;text-align:center;display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative;">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARYAAAC2CAMAAAAr+FInAAAA6lBMVEX///8eHhwAAAA5gcRjpNaLv+MPDwx4eHenp6YTExAXFxWRkZD39/YZGRfJyckHBwFPT07Z6vZHR0ZjY2LX19c3Nzbg4OBdXVyenp06hcru7u7o6OgoesEyfsOFhYQlJSOzs7PT4vFcntNsqtlHjMqUlJNvb25/tt5Ah8fCwsJDQ0IqKiicyOfB1utTls9en9N2sdx+fn0cFQA7OzmWxeW5ubmvyeWpz+l5ptXu9fqVuN2iwuLH4PEiNEUdGhK70umGr9maut4nRmQqT3QeIyczcKcwZpksV38mQFkdLTs2drISGiAVDAAgKTDKLYeCAAAOHklEQVR4nO2ceUPiOhfGS1pKC4Wyry2yFCggBRcU1FHH2eed+/2/zpu1pAtevQ6KmOePsZqQJr+enJyclJEkISEhISEhISEhISEhISEhISEhISEhISEhISEhIaG3kVHozrrrt+7Fnql779iy6zi9i7fuyT7pyrJcT+kvFn3HK7x1Z/ZGK8v2FGWRTCYvkz1ZcCG6smxHUUaQSqFQOJ47sZXW3buLi9kHQlawZFdR+pDKDGIpJJ3raJ2Lnm1ZtuvKztVHccv3NptCiErhrh8xl65r2bIzh+z6imNdvUUnX1+Obc/JHLpBWG4WbmiqXFi2jaGgOqO+Pf8IBlOwZVshWJLHl5eX5yPnLlDhwpKR78E1jm9m5wt59UZdfU1B14KwoElEtAg6l4Isy4zKOTKn8751eNHNOjwDEJYeHLaPpe995stXtizPiUumswwu4sYr9nj3mq0c1/Huu/zf4CSSocslngNRUQLWgooDxlIoXI7kQzKX9cqCAFAoe8//1YWzRMHqQ8Ef1owrvrZkmRkTxXIz8nqv3PVdyrMcNBeOZ5ce7zTn1B6YHHsdKp2zOXZDsCQV+bX7vjtdWS4eHQplHc4g7qA92G6PQuk5VmChcWSChU6x8+Pj82RSsQ8m3F3LMGqDxnIJsXQXc64Ebp4hGNlxPMdxZTsw5LUcxEKk2N1w8+9VMwtGbWgOddE0cLiJ0rVkTsHV18fS56gsFHsWbv69CvrOuT+4kcM/7jvLZlBsK7gjMpBDRgsVF9iMoFc+GGu5stFTZ8/bDTzubg9uBKEsqxcerweJuWSdIvNotIAOyDoY33KNkyrER4wUNzT87udVr7e6jhoBiuZk5o/JAg4XK/lgtkUziz11OLT5k8d1YTHvspFnz//9g+9Ea5kLT+Qnj2tN3E4vQMU6GI+L4hYExoNy5Ge4zHvMxXa9Ho1r4BIeTeCtu93C+5xYa4cMELnWZ6SS1v4i5f8bhnq3ki3ks93VXXwbe621hxdiSOXzv1fe6C4Q1kQiG+lChs0SW/Jk5z1Or4u5C3eLV89cXS82YQ2mGqRyzxKaOHfnvc+cphHJtzxBM8cHY4cjm7lFwj288F8eJ5X3yeU/aX3hIe9h2c4qNEmuOCrncFsxSyqHtEz9q9bdWcwZdcEiq/7CTzvMkp6757m7wtV89XmnyyaKgVmS6pgkqY4X9n7n7maW1x+dz3e4q1tbZMOEd6CXNHeX9Lzd3fHlWtteH/b1ZoeB+h2dQzyWQlKx9zmwu7PmEEv3pr87c7li6XG8tz6+u4G6TCryPjvdzwgLSqXtLvRcBbD4ubu9Phi4tnrKYjRaeLt7dh7FogSxuDGH+3ujroXz1k/PITxfHjs04M2lr7jP2ly8tlaW7LruLqPOlZ+6485qFcXeZ2tBx2WWJe/yyd1zqbsFzfuhlOaeb6TXN7t9eRKn7lwlJOdwMr3/TWucc3CCVDx7r8O511AP76xdLqU5d8JnKh9QM5qich2vN4fqOSi/uc9B7uto7idiNinNfY5xX0lrl8/c4ZTmx0lDPaKCE+DyrOz5IQtGR9wJ9rtMce9G3ZVtEXmvF8cZauLoSB2wX1vtTL092LO04Lp7cX19cfOaK5ABstksyNDfqidNyZCqqUe43PW8+8MPMw2QSCRMhiUlDczspFodbK1/J/eTs8XBhw4BLGVNytSl4YnU3mounrc4LlzucyLoryiAZZyTMsV2ZSkNqtvqyx7c5C8OfpkMWstSygxPipKUaW6r77lzuF37WNZitNEkOuvAn9uEXoSznY/lW6ROBy5EUrO9dQ5J0s3K2+2Z2V4oiEXqtMflTqr8lj3aC4WwSEZuKaBEsRy6jKdF8M/GMtagOvCiOqhDkbtUO5lSPl9KabxT6qDyMb5s5rRULV8btsfxS1xrCT9fzJcGy1bg72XURJ1cV7WTfLFYOtG2WXMZ3qNYrLU7WzxjuT7Mn1UqxWGdtNAZIqGrDLrosEbyZ6XnYxkCqDN4kUMXAGIxBhUATD2d1lVYovk1a6gcrWnlkg6AqsNyE+il6KiWRfL5tG4CkF9yJRpqQsdjmKA6f/78gVUqgyjcJuqESjsx0SLlRidvAjUNdzppFZh59LTaQFVVgAqL8ApvgJa4kpp/PpaUmkikixgL/GTCkJY6yCZ8ZUGFjbuk45aNFFA35QkVnAQbHE9BmitPg+mYwwJbPIJgKyB9e/r108OXLw+fvv4BZj3Uq7rKdyLQBlZuEriJDkpNKWOi7qDSPCwzB1KzBHT88drLsQz4/pA+jXksRgUEyxOgyM/vYfjzkGwqhGUJoSS+fJMbjYbjOO63L7cgzxuMkWeNZNlPEAi96j4UVsGstMJYjIlJob0Yy3QAiAlg6XTcZR+L2i6quJdYJumTWdwMqAgoSyLSe5DnsVTgnU4f5IYsO+gMoK/0XPkBTDdeqDlVCQpgTo/gJMN3AaVNn9vkJlkTZKfTBLmLPhnqPBY1U8Ot4In8YmtBTQFwsixXq2WtRsAgs6dYEuk0GvNZPVetVnOZKekf8OdA3iRQ8lq5ZbTKWp6AAbUNFvSET7836He18OniqNf4DirM5owKIX9GHH5VO8KfAkN2kzq96zRTbhpGs6pNELksvpOPJVFB/wC1VO90xi/GgvqzmeitPNgMu0SNxzzbeNkOfZR0SClSfbJZO8oT8qc2hyVx+q1BviyNz+jP0RuXkAszhyGqlFY5V13HdwEd8hvpaJb3R8sj2jcOC7IUla6sL8eSBYGlpYSf3JTDYpb48rLJmQtpIuSDicWTVgkWbCseO6FHr0XdQS4/wHLTSPoosLKXCRfifyZpbMGBbjaLahSLunk8L8YCcoFiI5FlgyJY0pPg5zt4FMR5ELtNBSsQE9JrPpbbnw3uHTry/dfLZM/+VdmM2gzGO6RzZpsgwkMOxQXNs3QYS7qyceMv9i2h5ZaMBGg+FhAOripZNotwC9mzyC0qPlnc2OlvmXzFHL+0MKNvXI6c73jJy/n3CygD2F2GamwF+lQ5LPwDfikWEHpMUhP9WR0yLOow3ABeF/GgSYdz4QrSGDDeCItvLOSlqC5747Jn/29IG6E+npeB24bcDLQkZyvRgeC7c1j0Gv/xl2EJtEWEnjWeJBgLGIfL8aCxX9hiLJJ0lKX+CWFBnoV7V4y+cFk477sPMEQ1UF0Qju5QP3WCdos1+daOLjEWwIfXL8QS0yFEIzuhFwkzEqdXAV0l8IUZl00nBtWi1oLm0AbLJfsSeR/OoiptLbKhqI5RVIKMBK/OEZtGI8dzdYMl0NOXYllGKmCrRkZb0mOtt8keHzGb6BziShCWrzJ1Lf6bhedQ6P+w+A1NcYmr8h8ud9pwZ0MiKEC7k4gbSSkQzgV7+lIs0Y1fKoClGCk3GBbinOO21GVmUKjKr0YYC3230JNhFdyISj7WLGsncMMIN3tk8YWbQkOq6f7CF1I7EPwH6+wYS/oRLANzG5YWR+4WYwl9Vxq/iOrZcAqjOQLdUCtXLx0hImR7kUUhfLrWhmTPsrEeUKL397EE67whlvpWa6nyBvVPg32FPPBfDvQVaC0aDewREZ0jMq1lljQwmGzFktlPLNo2ZxicRBgLfbFwxFFRHDSJOiSyp0QgnUptMG5xW/RavIeDOlH3Ess2n00jYdQ0Jif7PhcGuosR0gJ/rfg39MpsCwL38GalVI9m/8jg41KVxfReYsEeRI07kkJN4AUTxy3f5Lj3UBUH7habpJHEUWVYz8XZHbPJmPWuFdxB7w0WErVFA1QuzsNxy49GzHuo0LM0Hm4lEj3GxoRUZT/qDkkDe4qFRG3RAJQ84AG9wktR6D1U5FhkGWcfSCNx0Q/VFO+wImlvEs3tIxa84ETj4CbZbKGBkK3iN/qOGPtqvdLz4K+NH/jmuBGSyYgXDk/0SOTSDm0VY7DETvAt+otYSHJGD8+ACd404HQDSSx8agS/Wk9+/P5Dhoq3fGpkCe6wXUUrLqnDElzbsEiJ7LYoMF5/EwvpsXrG20tzghNZenPT+dMfPhdOn+i9SSNmPmh0A+CvcTSvNTQCxYnHsZBN9SNn8TvEQoetm5qfl9XSZDOz5MrJJjqkn/6bbdR36vUNmNwEbNKGBja/hFnRaAVjjHOrj61EbOo9+S3Cv4qFzXCQGHbGuVwndURzvQN+xEfpMJfG709cZp80kgVqrb7M5cadFDl50tkGsUoIZMHRsK5p9VQFF6ulR+IWltM7q+fK4/bWt312hQUOKcvCMX9Lkw0agpmb6qc/f/tgGg35h382gJWhx0Q6CLTip3rK5MSEbAxoMciMwSNYiN9DZyhQ8RHRLrHAiJY/c8SPiKXs/f1BswJubx++IyIQzrcvX/8ET8diGkkAPqfdyocO6dLQHh/H0vIPB+IGuXMsUqvEjtXo4xlubJZgqSKjMm9PT//59PPTr9tTc3Ogy9RMgeCRLwi9FalNgT9MaFWTHMnqZLdikapnrMXHoiImfDRfkdjRfBQLroBi1xo7xA9jQeKDuGob7YBNFRnsUYb3/j4WqdVGpdikwTCum836BFUgrVTqEXdgLEs6O7os4ek1xr+gK/RJEF2NtTN6yydgKeeQUD/wRdRVV9Gfy6xmjP3hz4Wma3Vcz5xk6uPQnzdYUHudTLs9eOStpGZOgzUyWm6LizTKS62udcrsiKyKhK5a6CLOgVSX2iDSqbdXAIsQk8ASK4ElVgJLrASWWAkssRJYYiWwxEpgiZUGo3lTYAkr185kMk9JdwgJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkdqv4P9UdXuSSSScwAAAAASUVORK5CYII=" alt="">
            <br/>
            <span class="search_field_name" >Scouting brief <br/>{{search_field.name}}</span>
            <span style="margin-top:50px">Date :  {{ $filters.formatDateUS(new Date()) }}</span>
            <div style="position:absolute;bottom:1cm;left:1cm;font-size:10px; text-align:left;">
              Innopearl SARL<br/>
              Cours des Bastions 13,<br/>
              CH-1205 Genève<br/>
              Switzerland
            </div>
            <div style="position:absolute;bottom:1cm;right:1cm;font-size:10px; text-align:left;">
              Contact : Olga Guerous<br/>
                 Email : olga.guerous@innopearl.ch
            </div>
          </section>

            <section style="width:100%;
            display:flex;flex-direction:column;position:relative;padding-left:50px;padding-right:50px;margin-top:100px;">
              <div style="display:block;text-align:left;">
                <H2 style="color:#3783C5;">Contents</h2>
                <br><h3 style="word-spacing:7px;font-size:20px; line-height:30px;">1. Business objective</h3>
                <br><h3 style="word-spacing:7px;font-size:20px; line-height:30px;">2. Scouting brief</h3>
                <br><h3 style="word-spacing:7px;font-size:20px; line-height:30px;">3. Selection requirements</h3>
              </div>
            </section>

            <div class="html2pdf__page-break"/>
        <section>
          <div style="margin-left:5%;margin-right:5%;width:90%;margin-top:50px;display:block;text-align:center;">
            <h2 style="word-spacing:5px;color:#3783C5;font-size:30px;line-height:30px;">Business Objective</h2>
          </div>
            <div style="margin-left:5%;
            margin-right:5%;width:90%;margin-top:50px;display:block;">
                <div class="scouting_brief_item">
                  <span class="scouting_brief_item_title" style="letter-spacing: 1px;font-size:14px;">PROBLEM TO BE SOLVED <span class="scouting_brief_item_subtitle"> (from your business challenge)</span></span>
                  <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;white-space: pre-wrap;">
                    {{search_field.scouting_challenge.scouting_brief.problem_to_be_solved.value}}
                  </div>
                </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;font-size:14px;">PARTNERSHIP OBJECTIVE <span class="scouting_brief_item_subtitle">(from your business challenge)</span></span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;white-space: pre-wrap;">
                      {{search_field.scouting_challenge.scouting_brief.partnership_objectives.value}}
                    </div>
                  </div>
              </div>


            </section>

            <div class="html2pdf__page-break"/>
            <section>
              <div style="margin-left:5%;margin-right:5%;width:90%;margin-top:50px;display:block;text-align:center;">
                <h2 style="word-spacing:5px;color:#3783C5;font-size:30px; line-height:30px;">Scouting brief</h2>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;font-size:14px;">RECOMMENDED TOPICS / TECHNOLOGIES</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;white-space: pre-wrap;">
                      {{search_field.scouting_challenge.scouting_brief.recommanded_topics.value}}
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;font-size:14px;">RECOMMENDED APPLICATION AREA(S)</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;white-space: pre-wrap;">
                      {{search_field.scouting_challenge.scouting_brief.recommanded_application_area.value}}
                    </div>
                  </div>
              </div>
            </section>

            <div class="html2pdf__page-break"/>
            <section>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:100px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;font-size:14px;">ANTICIPATED IMPACT ON BUSINESS OR OPERATING MODEL</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;white-space: pre-wrap;">
                      {{search_field.scouting_challenge.scouting_brief.anticipated_impact.value}}
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;font-size:14px;">OTHER CONSIDERATIONS OR POTENTIAL HURDLES</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;white-space: pre-wrap;">
                      {{search_field.scouting_challenge.scouting_brief.key_engagment_steps.value}}
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;" v-if="search_field.scouting_challenge.scouting_brief.extra_info">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;font-size:14px;">ADDITIONAL INSIGHTS</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;">
                      {{search_field.scouting_challenge.scouting_brief.extra_info}}
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;text-align:center;" >
                  <span style="display:block;color:#3783C5;text-transform:uppercase;font-size:10px;line-height:20px;margin-top:20px;letter-spacing:1px;">Keep your name confidential for potential candidates?</span>
                  <label class="rocker mt20">
                    <input type="checkbox" v-model="search_field.scouting_challenge.scouting_brief.keep_name_confidential">
                    <span class="switch-left">YES</span>
                    <span class="switch-right">NO</span>
                  </label>


            </div>
            </section>



            <div class="html2pdf__page-break"/>
            <div style="margin-left:5%;margin-right:5%;width:90%;margin-top:50px;display:block;text-align:center;">
              <h2 style="word-spacing:5px;color:#3783C5;font-size:30px; line-height:30px;">Selection requirements</h2>
            </div>
            <section>

              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;">Solution development stage</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;">
                      <ul>
                        <li v-for="(s, i) in search_field.scouting_challenge.candidate_selection_requirements.development_stage" :key="i">{{labelize(s,'development_stage')}}</li>
                      </ul>
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;">Fundind stage</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;">
                      <ul>
                        <li v-for="(s, i) in search_field.scouting_challenge.candidate_selection_requirements.funding_stage" :key="i">{{labelize(s,'funding_stage')}}</li>
                      </ul>
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;">Partner's location</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;">
                      <ul>
                        <li v-for="(s, i) in search_field.scouting_challenge.candidate_selection_requirements.location" :key="i">{{labelize(s,'location')}}</li>
                      </ul>
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;">WHAT TYPE OF ASSETS / CAPABILITIES A POTENTIAL PARTNER MUST HAVE?</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;">
                      <ul>
                        <li v-for="(s, i) in search_field.scouting_challenge.candidate_selection_requirements.capabilities_assets" :key="i">{{labelize(s,'capabilities_assets')}}</li>
                      </ul>
                    </div>
                  </div>
              </div>
              <div style="margin-left:5%;
              margin-right:5%;width:90%;margin-top:50px;display:block;" v-if="search_field.scouting_challenge.candidate_selection_requirements.comments">
                  <div class="scouting_brief_item">
                    <span class="scouting_brief_item_title" style="letter-spacing: 1px;">Comments</span>
                    <div class="scouting_brief_item_content" style="font-size:10px;letter-spacing: 1px;padding:20px;">
                      {{search_field.scouting_challenge.candidate_selection_requirements.comments}}
                    </div>
                  </div>
              </div>
            </section>


      </template>
  </vue3-html2pdf>
</div>
<div id="" class="" v-else>
  <div class="container ">
     <div class="pt50 ">
      <div class="alert alert-warning">
        Not available
      </div>
    </div>
  </div>

</div>
    </div>



</template>
<script>
 import AddCommentModal from '@/components/modals/addComment.vue'
 import NewValueModal from '@/components/modals/addValue.vue'
// import BookACall from '@/components/bookacall.vue'
 import { toast } from 'vue-sonner'
import Vue3Html2pdf from 'vue3-html2pdf'
import api from '../tools/api';
//import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import countries from '@/assets/db_coutries.json';

import Treeselect from 'vue3-treeselect'
// import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css'
import BlockedModal from '@/components/modals/blockedModal.vue'
import ScoutingNextStepInfo from  '@/components/modals/ScoutingNextStepInfo.vue'


export default {
  components: {
     AddCommentModal,
     NewValueModal,
     Vue3Html2pdf,
     //ConfirmModal,
     Treeselect,
     BlockedModal,
     ScoutingNextStepInfo
    // BookACall
  },
  data() {
    return {
      dialog : false,
      showEdited : false,
      showScoutingNextStepInfo:false,
      blockSaveAndSubmit: false,
      formMessage: "",
      showBockedDialog: false,
      showDevStageToolTip:false,
      dialogAssets: false,
      addMoreInfo : false,
      showConfirmDialog: false,
      add_other_location: "",
      currentSearchFieldForComment : "",
      step: 1,
      pageInfo: {
        mainTitle : "Scouting space",
        subTitle : "Find the most relevant partners",
      },
            execution_geography_possibles: countries,
      options: [ {
        id: 'a',
        label: 'a',
        children: [ {
          id: 'aa',
          label: 'aa',
        }, {
          id: 'ab',
          label: 'ab',
          children: [ {
            id: 'aba',
            label: 'aba',
          }, {
            id: 'abb',
            label: 'abb',
          } ]
        } ],
      }, {
        id: 'b',
        label: 'b',
      }, {
        id: 'c',
        label: 'c',
      } ],
      search_field : {
        name : 'Search field 1',
        confidential : true,
        more_info: "",
        problem_to_be_solved: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: ['tests'],
        },
        recommanded_application_area: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        partnership_objectives: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        anticipated_impact: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        recommanded_topics: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        key_engagment_steps: {
          value : "Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: []
        },
        isSubmit : false,
      },
      candidate_selection_requirements:{
        location: [],
        funding_stage: ["seed"],
        development_stage: [],
        capabilities_assets: [],
        already_identified: false,
        comments: []
      },

      location_possibles: [
        {
          name: "EU",
          value: "eu"
        },
        {
          name: "US",
          value: "us"
        },
        {
          name: "Asia",
          value: "asia"
        },
        {
          name: "All",
          value: "all"
        },
      ],
      capabilities_assets_possibles: [],
      funding_stage_possibles: [
        {
          name: "Don't know / Not relevant",
          value: "not_relevant"
        },
        {
          name: "Pre-seed",
          value: "preseed"
        },
        {
          name: "Seed",
          value: "seed"
        },
        {
          name: "Series A",
          value: "seriesA"
        },
        {
          name: "Series B",
          value: "seriesB"
        },
        {
          name: "Series C",
          value: "seriesC"
        },
        {
          name: "IPO",
          value: "IPO"
        },

      ],
      solution_developement_stages: [
        {
          name: "Research",
          value: "research"
        },
        {
          name: "Prototype",
          value: "prototype"
        },
        {
          name: "MVP",
          value: "mvp"
        },
        {
          name: "Testing",
          value: "testing"
        },
        {
          name: "Commercial Launch",
          value: "launch"
        },
        {
          name: "Scaleup",
          value: "scaleup"
        },
        {
          name: "At scale",
          value: "atscale"
        },
      ]
    }
  },
  methods:{
    closeBlockedDialog: function(){
      this.showBockedDialog = false;
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    openModal(search_field){
      this.currentSearchFieldForComment = search_field;
      this.dialog = true;
    },
    closeModal(){
      this.currentSearchFieldForComment = "";
      this.dialog = false;
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
    },
    save(notify){
      console.log(this.search_field.scouting_challenge);
      // if(this.blockSaveAndSubmit == false){
      // this.locker().then(() => {
      //         if(this.blockSaveAndSubmit == false){

      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/save/"+this.$route.params.search_field_id,this.search_field.scouting_challenge,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
        if(notify)toast.success("Your scouting brief is saved. ");

    }).catch( (e) => {
      console.log(e);
        if(notify)toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
    //     }
    // });
    //   }

  },
    update(notify){
      console.log(this.search_field.scouting_challenge);
      // if(this.blockSaveAndSubmit == false){
      // this.locker().then(() => {
      //         if(this.blockSaveAndSubmit == false){

      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/save/"+this.$route.params.search_field_id,this.search_field.scouting_challenge,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
        if(notify){
          toast.success("Your scouting brief is updated. ");
          api.get(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/"+this.$route.params.search_field_id).then( (r) => {
            console.log(r.data);
            this.search_field = r.data;
            if(this.search_field.scouting_challenge.editedFields) this.showEdited = true;
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
         });

        }

    }).catch( (e) => {
      console.log(e);
        if(notify)toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
    //     }
    // });
    //   }

  },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/add_comment/"+this.$route.params.search_field_id,
        {
          comment : v,
          topic : this.currentSearchFieldForComment
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        toast.success("Comments added");
        this.search_field.scouting_challenge.scouting_brief[this.currentSearchFieldForComment].comments.push(r.data);
          this.currentSearchFieldForComment = "";
      }).catch( () => {
          this.currentSearchFieldForComment = "";
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

        // this.key_execution_factors_possibles.push({name:v,value:v,customer:true});
        // this.projet.key_execution_factors.push(v);
      }

      this.dialog = false;
    },
    addCustomLocation(){
      if(this.add_other_location != ''){
        this.location_possibles.push({name:this.add_other_location,value:this.add_other_location, custom: true});
        this.search_field.scouting_challenge.candidate_selection_requirements.location.push(this.add_other_location);
        this.add_other_location = '';

      }
    },
    confirmValid(){
          // this.locker().then(() => {
          //   if(this.blockSaveAndSubmit == false){
                this.showConfirmDialog = true;
          //   }
          // });

    },
    setNewValueCAS(v){
      // if(v){
      //   this.capabilities_assets_possibles.push({name:v,value:v.replace(/ /g,"_"),custom:true});
      //   this.search_field.scouting_challenge.candidate_selection_requirements.capabilities_assets.push(v);
      // }

      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict",
          {
              dict: 'dict_key_exection_factors_startups',
              value: v
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          this.capabilities_assets_possibles.push(r.data)
          this.search_field.scouting_challenge.candidate_selection_requirements.capabilities_assets.push(v);
        }).catch( (e) => {
          console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      }
      this.dialogAssets = false;
    },
    generateReport () {
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/save/"+this.$route.params.search_field_id,this.search_field.scouting_challenge,
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        this.$refs.html2Pdf.generatePdf()

      }).catch( (e) => {
        console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

    },
    labelize(val,dict){
        var found = val;
        var founded;
        if(dict == "funding_stage"){
          founded = this.funding_stage_possibles.find(element => element.value == val);
          if(founded)found = founded.name;
        }
        else if(dict == "development_stage"){
          founded = this.solution_developement_stages.find(element => element.value == val);
          if(founded)found = founded.name;
        }
        else if(dict == "capabilities_assets"){
          console.log(founded);
          founded = this.capabilities_assets_possibles.find(element => element.value == val);
          if(founded)found = founded.name;
        }
        else if(dict == "location"){
          console.log(founded);
          founded = this.execution_geography_possibles.find(element => element.id == val);
          if(founded)found = founded.label;
        }
        return found;
    },
    showScoutingNextStepInfoSet(){
      this.showScoutingNextStepInfo = false;
      window.open(
       'https://outlook.office365.com/owa/calendar/innopearl@innopearl.ch/bookings/',
       '_blank',
       'noopener,noreferrer'
     );

    },
    validateScoutingBrief(){
        this.showConfirmDialog =false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/submit/"+this.$route.params.search_field_id,this.search_field.scouting_challenge,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
      toast.success("Your scouting brief has been successfully created.");
      this.showScoutingNextStepInfo = true;
      this.search_field.scouting_challenge.isSubmit = true;
      if(this.search_field.scouting_challenge.candidate_selection_requirements.already_identified == true)this.$router.push('/my_pools/'+this.$route.params.search_field_id+'/'+this.$route.params.projectid);
      else  this.$router.push('/projet/'+this.$route.params.projectid);
    }).catch( (e) => {
      console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });

    },

    async locker(){
      await api.get(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/"+this.$route.params.search_field_id).then( (r) => {
        var d = r.data;
        if(d.scouting_challenge.locked){

            if(this.$store.state.uid != d.scouting_challenge.locked.user.$oid){
                 this.blockSaveAndSubmit = true;
                 var plural = (d.scouting_challenge.locked.expireDuration.toFixed() > 1) ? 's.' : ".";
                 var duration = (d.scouting_challenge.locked.expireDuration.toFixed() > 0) ? d.scouting_challenge.locked.expireDuration.toFixed() : "less than 1";
                 console.log(duration);
                 this.formMessage = d.scouting_challenge.locked.fullUser.firstname+" "+d.scouting_challenge.locked.fullUser.lastname+" is working on this project right now. Please wait for  "+duration+" minute"+plural+" before making any changes. ";

                 //this.formMessage = d.scouting_challenge.locked.fullUser.firstname+" "+d.scouting_challenge.locked.fullUser.lastname+" is currently working on this ressource. You can't save or submit data for "+duration+" minute"+plural;
                               toast.error(this.formMessage);
            }
            else{
                      this.blockSaveAndSubmit = false;
                      // this.showBockedDialog = false;
                     }
        }
        return "";
    });
  }
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

   api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_key_exection_factors_startups").then( (r) => {
     this.capabilities_assets_possibles = r.data;
     console.log("tgfsdgsdgfsfg",r);
   }).catch( (e) => {
   if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
   else toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
   api.get(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/"+this.$route.params.search_field_id).then( (r) => {
     console.log(r.data);
     this.search_field = r.data;
  if(this.search_field.scouting_challenge.editedFields) this.showEdited = true;
     if(this.search_field.scouting_challenge.scouting_brief.isNew){
       //unset new
       api.post(process.env.VUE_APP_API_URL+"/restrict/scouting_brief_unnew",this.search_field,{
           headers: {
               'Content-Type': 'application/json',
           }
       })
       .then( () => {})
       .catch( () => {});
     }
   }).catch( (e) => {
     console.log(e);
      toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
  });


},
watch: {
  step(v) {
    console.log(v);
      window.scrollTo(0, 0)
  }
}
}
</script>
<style >
.search_field_name{
  font-size: 30px;
  line-height: 36px;
  color: #3783C5;
  text-transform: uppercase;
}
.search_field_projectname{
  font-size: 15px;
  line-height: 22px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
}

.scouting_space_stepper{
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 50px;

}
.scouting_space_stepper .step{
  border-bottom: 1px solid #ADB3B5;
  position : relative;
  flex: 1;
  text-align: center;
  padding: 10px;
  text-decoration: none;
}
.scouting_space_stepper .step.active{
    border-bottom: 2px solid #3783C5;
}
.scouting_space_stepper .active:after{
  content: '';
position: absolute;
left: calc(50% - 15px);
top: 100%;
width: 0;
height: 0;
border-left: 15px solid transparent;
border-right: 15px solid transparent;
border-top: 15px solid #3783C5;
clear: both;
}
.scouting_space_stepper .stepNumber{
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.scouting_space_stepper .stepName{
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.scouting_space_stepper .active .stepNumber,
.scouting_space_stepper .active .stepName
{
  color: #3783C5;
}


.step_footer{
  /* display:flex;
  margin-top: 50px;
  align-items: center; */
  margin-top: 50px;
}
.step_footer .notice{
  flex: 1;
  font-size:14px;
  line-height: 22px;
  font-weight: 300;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
  text-decoration: none;
}
.next_step_btn img{
  margin-left:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}
.scouting_space_1,
.scouting_space_2,
.scouting_space_3{
  padding: 50px;
  background: #FFF;
}

.space_title_zone{
  margin-bottom: 50px;
}
.space_title{
  text-align: left;
  font-size: 21px;
  line-height: 25px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
opacity: 1;
display: block;
}
.zone_input{
}
.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
}
textarea.addValueInput{
  border: 1px solid #DDDDDD;
border-radius: 2px;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 background:#FFF;
 border: 1px solid #DDDDDD;
 width:100%;
}

.ml65{
  margin-left:65px;
}
textarea.comments{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
 resize: none;
 height:100px;
 padding: 10px;
}

.ligne_form{
  margin-top: 50px;
}

/*
.scouting_space_2 .row{
  margin-top:25px;
  margin-bottom: 25px;
}

.zone_input_subname{
  text-align: left;
  font-size:16px;
  line-height: 22px;
letter-spacing: 0px;
color: #3783C5;
margin-left: 65px;
}
.zone_input_checkboxes{
  margin-left: 65px;
  width: calc(100% - 65px);
  display: flex;
  margin-top:20px;
  gap: 20px;
  flex-wrap: wrap;
}

.partnership_objectivess_label{
  padding:12px 30px;
  background: #EFEFEF 0% 0% no-repeat padding-box;
border-radius: 3px;
min-width: calc(20% - 20px);
max-width: calc(20% - 20px);
flex-basis: 0;
flex: 1;
display:flex;
flex-direction: column;
gap: 10px;
border: 1px solid #EFEFEF;
}
input[type='checkbox']{
  width: 24px;
height: 24px;
margin-top:auto;
}
.checkbox_container{
  width:100%;
  display:block;
  text-align: right;
  align-self: end;
margin-top: auto;
}
.partnership_objectivess_label.add_other_objectif{
background:#FFF;
}
.add_other_objectif input{
  border:1px solid #EFEFEF;
  padding: 5px;
}
.checkbox_container button{
  font-size: 18px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}


.vselect_container{
  margin-top: 20px;
}
.vselect_container .v-field{
  background: #FFF !important;
  border: 1px solid #CCC;
}
.vselect_container .v-field__field,
.vselect_container .v-field__append-inner{
    background: #FFF !important;
}
.v-field--variant-filled .v-field__overlay {
  opacity: 0 !important;
}
.vselect_container .v-field__append-inner i {
  color: #3783C5;
}
.add_custom_key_factor{
  display: flex;
  justify-content: center;
}
.add_custom_key_factor_without_text{
  display: flex;
  justify-content: flex-end;
}
.add_custom_key_factor span{
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
  flex-grow: 1;
}
.add_custom_key_factor button,
.add_custom_key_factor_without_text button{
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #3783C5;
text-transform: uppercase;
}
.ligne_inner_form{
  margin-top:40px;
}
.inputs_container{
  margin-left: 65px;
}

.ligne_inner_form .vselect_container{
  margin-left:65px;
}
.v-autocomplete .v-field .v-field__input{
  padding: 7px;
min-height: 40px;

}
.search_field_input input{
  margin-top: 10px;
  margin-bottom: 10px;
} */


.scouting_brief_item{
  width: 100%;
border: 1px solid #DDD;
border-radius: 10px;
position: relative;
}
.scouting_brief_item_img{
  width: 55px;
position: absolute;
top: -25px;
left: -25px;
}
.scouting_brief_item_title{
  position: absolute;
top: 0;
left: 50px;
background: #FFF;
transform: translateY(-50%);
padding-left: 10px;
padding-right: 10px;
padding-top: 6px;
padding-bottom: 6px;
font-size: 16px;
line-height: 15px;
color: #3783C5;
}
.scouting_brief_item_subtitle{
  color: #000;
  font-size: 12px;
}
.scouting_brief_item_content{
  padding: 50px;
}
.scouting_brief_item_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
}
.scouting_brief_item_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:10px;
  line-height:15px;
    position:relative;
}
.scouting_brief_item_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.scouting_brief_item_comments small{
  font-size:10px;
}

.add_new_comment{
  font-size:10px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}

.scouting_space_content{
  margin-top: 50px;
}
.scouting_space_content .col{
  padding-left:20px;
  padding-right: 20px;
  margin-top:20px;
  margin-bottom: 20px;
}
.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}
.locationSelector{
  margin-top: 20px;
  padding-left: 65px;
}
.location_selection{
  font-size: 16px;
  line-height: 21px;
  color:#000;
  margin-top:20px;
  margin-bottom: 20px;
  display:block;
}
.location_selection input{
  width: 20px;
height: 20px;
}

.add_other_inline input{
  border: 1px solid #DDD;
padding: 5px;
border-right: none;
}
.add_other_inline button{
  border: 1px solid #DDD;
  padding: 5px;
  color: #3783C5;
  border-left: none;
  font-size:18px;
  line-height:22px;
  font-weight: 600;
}

.add_custom_key_factor{
  display: flex;
  justify-content: center;
}
.add_custom_key_factor_without_text{
  display: flex;
  justify-content: flex-end;
}
.add_custom_key_factor span{
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
  flex-grow: 1;
}
.add_custom_key_factor button,
.add_custom_key_factor_without_text button{
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #3783C5;
text-transform: uppercase;
}

.mt20{
  margin-top: 20px;
}

.myCheck{
  width:100%;
  display:flex;
  padding-left:50px;
  padding-right: 50px;
  margin-top:50px;
}
.mdl-checkbox {
flex: 1;
  text-align: center;
  padding: 10px;
  position: relative;
}

.mdl-checkbox:after,
.mdl-checkbox:before {
  height: 2px;
  background: linear-gradient(to right, transparent 50%, #DDD 50%);
  background-size: 10px 2px;
  content: "";
  top: 20px;
  position: absolute;
  right:0;
  left:0;
}

.mdl-checkbox:before {
  right: calc(50% + 12px);
}

.mdl-checkbox:after {
  left: calc(50% + 12px);
}


.mdl-checkbox:last-of-type:before {
  height: 2px;
  background: linear-gradient(to right, transparent 50%, #DDD 50%);
  background-size: 10px 2px;
  content: "";
  top: 20px;
  position: absolute;
  right:0;
  left:0;
}
.mdl-checkbox:last-of-type:after {
  background: transparent;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 24px dashed #DDD;
  float: right;
  left: calc(100% - 12px);
  height: 24px;
  width: 24px;
  top: 7px;

}
input.mdl-checkbox__input {
  width:24px;
  height:24px;
  border-width:1px;
  display: block;
  margin: auto;
  position: relative;
  z-index:50;
  accent-color:#3783C5;
}

.mdl-checkbox__label{
  margin-top:10px;
  margin-bottom:20px;
  font-size:14px;
  z-index:50;
  background:#FFF;
  position:relative;
}

@media screen and (max-width: 990px){
  .myCheck{
    width:100%;
    display:flex;
    padding-left:50px;
    padding-right: 50px;
    margin-top:50px;
    flex-direction: column-reverse;
    gap: 20px;
  }
  .mdl-checkbox::after, .mdl-checkbox::before {

    width: 2px;
    background: linear-gradient(to bottom, transparent 50%, #DDD 50%);
      background-size: auto;
    background-size: auto;
    background-size: 2px 10px;
    content: "";
    top: 0;
    position: absolute;
    right: 0;
    left: 50%;
    height: calc(100% + 20px);
  }

  .mdl-checkbox:last-of-type:before {

      width: 2px;
      background: linear-gradient(to bottom, transparent 50%, #DDD 50%);
        background-size: auto;
      background-size: auto;
      background-size: 2px 10px;
      content: "";
      top: -20px;
      position: absolute;
      right: 0;
      left: 50%;
      height: calc(100% + 60px);

  }
  .mdl-checkbox:last-of-type:after {
    background: transparent;
    border-right: 14px solid transparent;
    border-left: 14px solid transparent;
    border-bottom: 24px dashed #DDD;
    float: right;
    height: 24px;
    width: 24px;
    top: -50px;
    left: calc(50% - 14px);
  }
}


.next_step_btn img,
.prev_step_btn img{
  width:20px;
}

.row_center{
  align-items: center;
}

.mt50{
  margin-top: 50px !important;
}
.triangle_container{
  display:flex;
  margin-top:20px;
}
.triangle_left{
  width:45%;padding:10px;display:inline-block;
  position:relative;
  background: #3783C5 0% 0% no-repeat padding-box;
color:#FFF;
border-top-right-radius: 8px;
border-bottom-right-radius: 8px;
opacity: 0.85;
}
.triangle_right{
  position:relative;
  background: #3783C5 0% 0% no-repeat padding-box;
color:#FFF;
border-top-left-radius: 8px;
border-bottom-left-radius: 8px;
width:55%;padding:10px;display:inline-block;
}
.triangle_right:after{
  content: '';
  position: absolute;
  display: block;
  right: -25px;
  top: 0;
  bottom: 0;
  width: 25px;
  height: 100%;
  background: #3783C5;
  -webkit-clip-path: polygon(0 0, 0% 100%, 100% 50%);
  clip-path:polygon(0 0, 0% 100%, 100% 50%);

}
@media screen and (max-width: 990px){
  .triangle_container{
    display:none;
  }

}
.scouting_space_2{
  position:relative;
}
.explanation_needed{
  position:absolute;
  right: 20px;
  top: 20px;;
}

.downloadBtnWhite{
  border: 1px solid #3783C5;
border-radius: 50px;
color:#3783C5;
text-transform: uppercase;
  padding: 10px 10px 10px 10px;
  font-size:10px;
  line-height:15px;
}

.ml20{
  margin-left:20px;
}

@media screen and (max-width:690px){
  .ml0-xs{
    margin-left: 0 !important;
    padding-left: 0 !important;
  }
  .scouting_brief_item_content {
  padding: 25px;
}
.scouting_space_1,
.scouting_space_2,
.scouting_space_3{
padding-left:15px !important;
padding-right:15px !important;
}

}


.pt50{
  padding-top:50px;
}
[data-tooltip] {
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  position: relative;
}
[data-tooltip]::after {
  background-color: rgba(51, 51, 51, 0.9);
  border-radius: 0.3rem;
  color: #fff;
  content: attr(data-tooltip);
  font-size: 1rem;
  font-size: 85%;
  font-weight: normal;
  line-height: 1.15rem;
  opacity: 0;
  padding: 0.25rem 0.5rem;
  position: absolute;
  text-align: center;
  text-transform: none;
  transition: opacity 0.2s;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1;
}
[data-tooltip].tooltip-top::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
  top: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-top::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-bottom::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
  bottom: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-bottom::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-left::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
  top: 0.3rem;
  right: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-left::after {
  top: -0.3rem;
  right: calc(110% + 0.3rem);
}
[data-tooltip].tooltip-right::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
  top: 50%;
  top: 0.3rem;
  left: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-right::after {
  top: -0.3rem;
  left: calc(110% + 0.3rem);
}
@media (max-width: 767px) {
  [data-tooltip].tooltip-mobile::before {
    display: none;
  }
  [data-tooltip].tooltip-mobile:after {
    font-size: 1rem;
    max-width: 20rem;
    position: fixed;
    bottom: auto;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%);
    white-space: normal;
  }
}
[data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
  visibility: visible;
  opacity: 1;
}
@media screen and (min-width:990px){
  .stickitfooter{
    position: sticky;
    bottom: 0;
    background: #FFF;
    margin-left: -50px;
    margin-right: -50px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 15px;
    padding-bottom: 15px;
  }
}

.smallEditedLabel{
  color: #A8A8A8;
  font-size: 12px;
  display:block;
  width:100%;
  margin-top: -15px;
  margin-bottom: 20px;
}
.smallEditedLabelML{
    margin-left: 65px;
}
.smallEditedLabel.moremtp{
  margin-top: 15px;
}
.smallEditedLabel.nomtp{
  margin-top: 5px;
}
</style>
